import { useState } from 'react'
import type { RefObject } from 'react'
import type { AgGridReact } from 'ag-grid-react'
import { useQueryClient } from '@tanstack/react-query'
import { deleteItems } from '../../../shared/api/requestItems.api'
import { toast } from '../../../shared/ui/toastStore'

export function useDeleteSelectedItems(
  requestId: string | undefined,
  gridRef: RefObject<AgGridReact | null>,
) {
  const queryClient = useQueryClient()
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set())
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDeleteSelected = async (idsOverride?: string[]) => {
    const ids = idsOverride ?? Array.from(selectedIds)
    if (ids.length === 0 || isDeleting) return
    setIsDeleting(true)
    try {
      await deleteItems(ids)
      setSelectedIds(new Set())
      gridRef.current?.api.deselectAll()
      await queryClient.invalidateQueries({ queryKey: ['requests', requestId] })
    } catch (e) {
      // Причину сервера — дословно: например, позицию из счёта заказа удаляют
      // только в карточке заказа (аудит 30.09.2026). Раньше ошибка терялась молча.
      const msg = (e as { response?: { data?: { error?: { message?: string } } } }).response?.data
        ?.error?.message
      toast.error(msg ?? 'Не удалось удалить позиции')
    } finally {
      setIsDeleting(false)
    }
  }

  const cancelSelection = () => {
    setSelectedIds(new Set())
    gridRef.current?.api.deselectAll()
  }

  return { selectedIds, setSelectedIds, isDeleting, handleDeleteSelected, cancelSelection }
}
